export default __webpack_public_path__ + "static/Carousel-InstantDecoding@2x-79217ca13362e1834e1481c1574fa27d.png";